import React, { useEffect, useState, useRef, useContext, useCallback, useMemo } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import DayTime from '../../../common/DayTimeWrapper'
import { defaultPageSize, EMPTY_DATA, CBCTypeId, BOPIMPORT, EXCHNAGERATE, ZBCTypeId, VBCTypeId } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, showBopLabel, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { runVerifyBoughtOutPartSimulation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import { useForm, Controller } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import VerifySimulation from '../VerifySimulation';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import { debounce } from 'lodash'
import { PaginationWrapper } from '../../../common/commonPagination';
import DatePicker from "react-datepicker";
import WarningMessage from '../../../common/WarningMessage';
import { getMaxDate } from '../../SimulationUtils';
import ReactExport from 'react-export-excel';
import { APPLICABILITY_BOP_SIMULATION, BOP_IMPACT_DOWNLOAD_EXCEl, BOP_IMPACT_DOWNLOAD_EXCEl_IMPORT } from '../../../../config/masterData';
import { hideColumnFromExcel, parsedDate, updateCostValue } from '../../../common/CommonFunctions';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import { reactLocalStorage } from 'reactjs-localstorage';
import { simulationContext } from '..';
import LoaderCustom from '../../../common/LoaderCustom';
import { useLabels } from '../../../../helper/core';
import AddConditionCosting from '../../../costing/components/CostingHeadCosts/AdditionalOtherCost/AddConditionCosting';
import AddOtherCostDrawer from '../../../masters/material-master/AddOtherCostDrawer';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter } from '../../../../helper/simulationValidation';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';
import { useSimulationUndo, useSimulationGrid, useSimulationVBC } from '../../../../hooks/simulation';
import UndoButton from '../common/UndoButton';
import RedoButton from '../common/RedoButton';

const gridOptions = {

};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function BDSimulation(props) {
    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};

    const { list, isbulkUpload, rowCount, isImpactedMaster, tokenForMultiSimulation } = props
    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const gridRef = useRef();
    const [isDisable, setIsDisable] = useState(false)
    const [effectiveDate, setEffectiveDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false);
    const [titleObj, setTitleObj] = useState({})
    const [maxDate, setMaxDate] = useState('');
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [textFilterSearch, setTextFilterSearch] = useState('')
    const [rowData, setRowData] = useState([])
    const [basicRate, setBasicRate] = useState('')
    const [netCostWithoutConditionCost, setNetCostWithoutConditionCost] = useState('')
    const [openOtherCostDrawer, setOpenOtherCostDrawer] = useState(false)
    const [openConditionCostDrawer, setOpenConditionCostDrawer] = useState(false)
    const [otherCostDetailForRow, setOtherCostDetailForRow] = useState([])
    const [conditionCostDetailForRow, setConditionCostDetailForRow] = useState([])

    const [rowIndex, setRowIndex] = useState('')
    const [editRowId, setEditRowId] = useState('') // CRITICAL: Store ID instead of index
    const [isViewFlag, setIsViewFlag] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [scrapRateviewTooltip, setScrapRateViewTooltip] = useState(false)
    const [isCalculating, setIsCalculating] = useState(false)
    const [currentBopId, setCurrentBopId] = useState('') // CRITICAL: Store BoughtOutPartId for correct row identification  

    const tooltips = {
        basicRate: "To edit revised basic rate please double click on the field.",
        scrapRate: "To edit revised scrap rate please double click on the field."
    };
    const { register, control, setValue, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const dispatch = useDispatch()
    const { vendorLabel } = useLabels()
    const { selectedMasterForSimulation, selectedTechnologyForSimulation, isMasterAssociatedWithCosting, exchangeRateListBeforeDraft } = useSelector(state => state.simulation)
    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const simulationApplicability = useSelector(state => state.simulation.simulationApplicability)
    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)

    // Performance: Memoize configuration values
    const configKeys = useMemo(() => getConfigurationKey(), []);
    const isMinOrderQtyVisible = useMemo(() => configKeys.IsMinimumOrderQuantityVisible, [configKeys]);
    const decimalPlaces = useMemo(() => configKeys.NoOfDecimalForPrice, [configKeys]);
    const isBasicRateVisible = useMemo(() => configKeys.IsBasicRateAndCostingConditionVisible, [configKeys]);

    // ========================================================================
    // COMMON HOOKS - Using centralized simulation hooks
    // ========================================================================

    // Grid operations and pagination preservation
    const {
        gridApi,
        setGridApi,
        currentPage,
        currentPageSize,
        setCurrentPage,
        setCurrentPageSize,
        findNodeByRowId,
        refreshGridRow: commonRefreshGridRow,
        refreshMultipleRows: commonRefreshMultipleRows,
        onGridReady: commonOnGridReady,
        onPageSizeChanged: commonOnPageSizeChanged
    } = useSimulationGrid({
        defaultPageSize
    });

    // Undo functionality with keyboard shortcuts
    const {
        saveUndoState,
        handleUndo,
        handleRedo,
        undoCount,
        redoCount,
        canUndo,
        canRedo
    } = useSimulationUndo({
        gridApi,
        findNodeByRowId,
        disabled: isImpactedMaster,
        enableKeyboardShortcuts: true,
        updateListData: useCallback((rowId, restoredData) => {
            // CRITICAL FIX: Use ID instead of index to handle filtering correctly
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === rowId
            );
            if (actualIndex !== -1) {
                list[actualIndex] = restoredData;
                // Update grid node by ID
                const node = findNodeByRowId(rowId);
                if (node) {
                    node.setData(restoredData);
                }
            }
        }, [list, findNodeByRowId])
    });

    // VBC support - Costing type detection
    const {
        hasZBCRows,
        hasVBCRows,
        shouldShowConditionCostColumn,
        isVBCRow
    } = useSimulationVBC({
        list,
        ZBCTypeId,
        VBCTypeId,
        CBCTypeId
    });

    // Helper: Refresh specific row in grid
    const refreshGridRow = useCallback((rowIndex) => {
        try {
            if (!gridApi || typeof rowIndex !== 'number' || rowIndex < 0 || !list[rowIndex]) {
                console.warn('RefreshGridRow: Invalid parameters', { rowIndex, hasGridApi: !!gridApi, hasListItem: !!list[rowIndex] });
                return false;
            }

            const rowId = list[rowIndex]?.BoughtOutPartId || list[rowIndex]?.CostingId;
            if (!rowId) {
                console.warn('RefreshGridRow: No row ID found for index', rowIndex);
                return false;
            }

            const node = findNodeByRowId(rowId);

            if (node) {
                node.setData(list[rowIndex]);
                return true;
            }

            console.warn('RefreshGridRow: Node not found for row ID', rowId);
            return false;
        } catch (error) {
            console.error('Error refreshing grid row:', error);
            return false;
        }
    }, [gridApi, list, findNodeByRowId]);

    // Helper: Batch refresh multiple rows for better performance
    const refreshMultipleRows = useCallback((rowIndices) => {
        try {
            if (!gridApi || !Array.isArray(rowIndices) || rowIndices.length === 0) {
                return false;
            }

            const nodesToRefresh = [];
            rowIndices.forEach(rowIndex => {
                if (typeof rowIndex === 'number' && rowIndex >= 0 && list[rowIndex]) {
                    const rowId = list[rowIndex]?.BoughtOutPartId || list[rowIndex]?.CostingId;
                    if (rowId) {
                        const node = findNodeByRowId(rowId);
                        if (node) {
                            node.setData(list[rowIndex]);
                            nodesToRefresh.push(node);
                        }
                    }
                }
            });

            if (nodesToRefresh.length > 0) {
                gridApi.refreshCells({ rowNodes: nodesToRefresh, force: true });
                return true;
            }

            return false;
        } catch (error) {
            console.error('Error refreshing multiple rows:', error);
            return false;
        }
    }, [gridApi, list, findNodeByRowId]);

    // Note: saveUndoState, handleUndo, hasZBCRows, hasVBCRows, shouldShowConditionCostColumn
    // are now provided by common hooks above

    const columnWidths = {
        // Base column widths - used for compressed/expanded views
        COMPRESSED_WIDTH: 50,
        STANDARD_WIDTH: {
            SMALL: 80,
            MEDIUM: 120,
            LARGE: 160,
            EXTRA_LARGE: 190
        },

        // Main Information Columns
        BoughtOutPartNumber: showCompressedColumns ? 50 : 140,
        BoughtOutPartName: showCompressedColumns ? 120 : 140,
        BoughtOutPartCategory: showCompressedColumns ? 120 : 140,
        VendorCode: showCompressedColumns ? 120 : 140,
        CustomerName: showCompressedColumns ? 120 : 140,
        plantCode: showCompressedColumns ? 120 : 140,
        Quantity: showCompressedColumns ? 120 : 140,
        EffectiveDate: showCompressedColumns ? 150 : 150,

        // Cost Columns with Existing/Revised structure
        BasicRate: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },
        OtherCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 200
        },
        BasicPrice: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        ConditionCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        NetCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        PlantCurrency: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },

        // Legacy support for existing columnWidths usage
        NewNetCostWithoutConditionCost: showCompressedColumns ? 70 : 100,
        NetCostWithoutConditionCost: showCompressedColumns ? 70 : 100
    };
    // Separate useEffect to handle bulk upload count updates when isbulkUpload changes
    useEffect(() => {
        if (isbulkUpload && rowCount) {
            setValue('NoOfCorrectRow', rowCount.correctRow)
            setValue('NoOfRowsWithoutChange', rowCount.NoOfRowsWithoutChange)
            setTitleObj(prevState => ({ ...prevState, rowWithChanges: rowCount.correctRow, rowWithoutChanges: rowCount.NoOfRowsWithoutChange }))
        }
    }, [isbulkUpload, rowCount])

    useEffect(() => {
        if (!isImpactedMaster && !isbulkUpload) {
            list && list?.map(item => {
                // Only set default values if they don't already exist (to preserve bulk upload data)
                if (item.NewBasicRate === undefined || item.NewBasicRate === null) {
                    item.NewBasicRate = item.BasicRate
                }
                if (item.NewScrapRatePerScrapUOM === undefined || item.NewScrapRatePerScrapUOM === null) {
                    item.NewScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                }
                if (item.NewOtherNetCost === undefined || item.NewOtherNetCost === null) {
                    item.NewOtherNetCost = item.OtherNetCost
                }
                if (item.NewNetConditionCost === undefined || item.NewNetConditionCost === null) {
                    item.NewNetConditionCost = item.NetConditionCost  // ADD KEY FROM API
                }
                if (item.NewNetCostWithoutConditionCost === undefined || item.NewNetCostWithoutConditionCost === null) {
                    item.NewNetCostWithoutConditionCost = item.NetCostWithoutConditionCost
                }
                if (!item.NewBoughtOutPartOtherCostDetailsSchema) {
                    item.NewBoughtOutPartOtherCostDetailsSchema = item.BoughtOutPartOtherCostDetailsSchema || []; // Set to existing data or empty array
                }
                if (!item.NewBoughtOutPartConditionsDetails) {
                    item.NewBoughtOutPartConditionsDetails = item.BoughtOutPartConditionsDetails || []; // Set to existing data or empty array
                }
                setNetCostWithoutConditionCost(item.NewNetCostWithoutConditionCost)
            })
        }
    }, [])

    useEffect(() => {
        if (isImpactedMaster && handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, true);
        } else if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage);
        }
    }, [showverifyPage, isImpactedMaster]);
    useEffect(() => {
        if (list && list.length > 0) {
            window.screen.width >= 1920 && gridRef.current.api.sizeColumnsToFit();
            if (isImpactedMaster) {
                gridRef.current.api.sizeColumnsToFit();
            }

            let tempList = [...list]
            if (simulationApplicability?.value === APPLICABILITY_BOP_SIMULATION) {
                tempList = [...exchangeRateListBeforeDraft]
            }
            let maxDate = getMaxDate(tempList)
            setMaxDate(parsedDate(maxDate?.EffectiveDate));
        }
    }, [list])

    // Note: Keyboard shortcuts (Ctrl+Z) are now handled by useSimulationUndo hook

    // Memoized calculation function to prevent race conditions
    const calculateCostsForRow = useCallback((rowId, rate) => {
        if (!list || !rowId || isImpactedMaster || isCalculating) {
            return;
        }

        // CRITICAL FIX: Find actual index by ID, not by visual index
        const index = list.findIndex(item => {
            const itemId = item.BoughtOutPartId || item.CostingId;
            return itemId === rowId;
        });

        if (index === -1 || !list[index]) {
            console.error('Row not found with ID:', rowId);
            return;
        }

        setIsCalculating(true);

        try {
            // Store current pagination state
            const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
            const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

            let obj = { ...list[index] }; // Create a copy to avoid direct mutation
            obj.otherCostTableData = obj.NewBoughtOutPartOtherCostDetailsSchema || [];
            obj.conditionTableData = obj.NewBoughtOutPartConditionsDetails || [];

            // CRITICAL FIX: Update ApplicabilityCost in the table data for percentage-based costs
            // When Applicability is "Basic Rate" and Type is "Percentage", we need to update
            // the ApplicabilityCost to the NEW basic rate before recalculating
            if (obj.otherCostTableData && Array.isArray(obj.otherCostTableData)) {
                obj.otherCostTableData.forEach(item => {
                    if (item.Type === 'Percentage' && item.Applicability === 'Basic Rate') {
                        item.ApplicabilityCost = rate;
                        item.ApplicabilityCostConversion = rate;
                        // Recalculate NetCost based on new basic rate
                        const percentageValue = parseFloat(item.Value) || 0;
                        item.NetCost = (rate * percentageValue) / 100;
                        item.NetCostConversion = item.NetCost;
                    }
                });
            }

            // CRITICAL: Save the updated table data back to the schema
            obj.NewBoughtOutPartOtherCostDetailsSchema = obj.otherCostTableData;

            const updatedObjOtherCost = updateCostValue(false, obj, rate, true);

            // Update with the recalculated values
            obj.NewBoughtOutPartOtherCostDetailsSchema = updatedObjOtherCost?.tableData || [];
            obj.NewOtherNetCost = updatedObjOtherCost?.formValue?.value || 0;
            obj.NewOtherNetCostConversion = updatedObjOtherCost?.formValue?.value || 0;
            obj.NewOtherNetCostLocalConversion = updatedObjOtherCost?.formValue?.value || 0;

            // Allow negative values for discounts - don't use checkForNull for adding costs
            const otherCostValue = updatedObjOtherCost?.formValue?.value || 0;
            const basicPrice = preciseAdd(checkForNull(rate), otherCostValue);

            const updatedObjConditionCost = updateCostValue(true, obj, basicPrice, true);
            obj.NewBoughtOutPartConditionsDetails = updatedObjConditionCost?.tableData || [];

            const conditionCostValue = updatedObjConditionCost?.formValue?.value || 0;
            obj.NewNetConditionCost = conditionCostValue;
            obj.NewConditionNetCostConversion = conditionCostValue;
            obj.NewConditionNetCostLocalConversion = conditionCostValue;

            // Calculate costs allowing negative values from discounts
            obj.NewNetLandedCost = preciseAdd(checkForNull(rate), otherCostValue, conditionCostValue);
            obj.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(rate), otherCostValue);
            obj.NewNetLandedCostConversion = obj.NewNetLandedCost;
            obj.NewNetLandedCostLocalConversion = obj.NewNetLandedCost;

            setNetCostWithoutConditionCost(obj.NewNetCostWithoutConditionCost);
            list[index] = obj;

            // Update pagination state
            setCurrentPage(savedPage);
            setCurrentPageSize(savedPageSize);

            // Refresh grid cells without full reload using helper
            refreshGridRow(index);

            setIsCalculating(false);
        } catch (error) {
            console.error('Error in calculateCostsForRow:', error);
            setIsCalculating(false);
            Toaster.error('An error occurred during calculation. Please try again.');
        }
    }, [list, isImpactedMaster, isCalculating, gridApi, currentPage, currentPageSize]);

    useEffect(() => {
        if (list && editRowId && !isImpactedMaster && basicRate !== '') {
            // Use timeout to debounce rapid changes
            const timeoutId = setTimeout(() => {
                calculateCostsForRow(editRowId, basicRate);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [basicRate, editRowId, openOtherCostDrawer, openConditionCostDrawer])

    const apiCall = (check, tempList) => {
        const filteredMasterId = masterList?.find(item => item?.Text === "BOP Import")?.Value;
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(list?.[rowIndex]?.NumberOfPieces) : 1;
        let obj = {};
        obj.SimulationTechnologyId = check ? EXCHNAGERATE : selectedMasterForSimulation.value;
        obj.SimulationTypeId = list[0]?.CostingTypeId;
        obj.LoggedInUserId = loggedInUserId();
        obj.TechnologyId = selectedTechnologyForSimulation?.value ? selectedTechnologyForSimulation?.value : null;
        obj.TechnologyName = selectedTechnologyForSimulation?.label ? selectedTechnologyForSimulation?.label : null;
        obj.EffectiveDate = DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss');
        obj.IsSimulationWithOutCosting = !isMasterAssociatedWithCosting;
        obj.ExchangeRateSimulationTechnologyId = filteredMasterId

        let tempArr = [];
        list && list.map(item => {
            if (item.NewBasicRate !== undefined ? Number(item.NewBasicRate) : Number(item.BasicRate)) {
                let tempObj = {};
                tempObj.BoughtOutPartId = item?.BoughtOutPartId || "00000000-0000-0000-0000-000000000000";
                tempObj.OldBOPRate = item?.BasicRate || 0;
                tempObj.NewBOPRate = item?.NewBasicRate ? item?.NewBasicRate : item?.BasicRate || 0;
                tempObj.OldNetLandedCost = item.NetLandedCost || 0;
                tempObj.NewNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(item?.NewBasicRate ? item?.NewBasicRate : item?.BasicRate), checkForNull(item?.NewOtherNetCost)), NumberOfPieces), checkForNull(item?.NewNetConditionCost));
                tempObj.NewOtherNetCost = item?.NewOtherNetCost || 0;
                tempObj.NewNetConditionCost = item?.NewNetConditionCost || 0;
                tempObj.NewNetCostWithoutConditionCost = item?.NewNetCostWithoutConditionCost || 0;
                tempObj.BoughtOutPartConditionsDetails = item?.NewBoughtOutPartConditionsDetails || [];
                tempObj.BoughtOutPartOtherCostDetailsSchema = item?.NewBoughtOutPartOtherCostDetailsSchema || [];
                tempArr.push(tempObj);
            }
            return null;
        });
        obj.SimulationHeadId = list[0]?.CostingTypeId

        obj.SimulationBoughtOutPart = tempArr;
        obj.SimulationIds = tokenForMultiSimulation;

        if (check) {
            obj.SimulationExchangeRates = tempList;
            obj.IsExchangeRateSimulation = true;
        }

        dispatch(runVerifyBoughtOutPartSimulation(obj, res => {
            setIsDisable(false);
            if (res?.data?.Result) {
                setToken(res?.data?.Identity);
                setTimeout(() => {
                    setShowVerifyPage(true);
                }, 200);
            }
        }));
    }

    const verifySimulation = debounce(() => {
        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }

        // VALIDATION: Check for invalid data before proceeding
        let hasInvalidData = false;
        let hasNegativeBasicRate = false;
        let hasNegativeScrapRate = false;
        let hasScrapGreaterThanBasic = false;
        let invalidRowNumbers = [];
        let scrapRateIssueRows = [];

        list && list.forEach((li, index) => {
            const newRate = li?.NewBasicRate;
            const newScrapRate = li?.NewScrapRatePerScrapUOM;

            // Check if NewBasicRate exists and is a valid number
            if (newRate !== undefined && newRate !== null && newRate !== '') {
                const numericRate = Number(newRate);

                if (isNaN(numericRate)) {
                    hasInvalidData = true;
                    invalidRowNumbers.push(index + 1);
                } else if (numericRate < 0) {
                    hasNegativeBasicRate = true;
                    invalidRowNumbers.push(index + 1);
                }
            }

            // CRITICAL: Validate Scrap Rate
            if (newScrapRate !== undefined && newScrapRate !== null && newScrapRate !== '') {
                const numericScrapRate = Number(newScrapRate);
                const basicRateValue = Number(newRate || li?.BasicRate || 0);

                if (isNaN(numericScrapRate)) {
                    hasInvalidData = true;
                    invalidRowNumbers.push(index + 1);
                } else if (numericScrapRate < 0) {
                    hasNegativeScrapRate = true;
                    scrapRateIssueRows.push(index + 1);
                } else if (numericScrapRate > basicRateValue) {
                    hasScrapGreaterThanBasic = true;
                    scrapRateIssueRows.push(index + 1);
                }
            }

            // Validate other cost values (can be negative - discounts allowed)
            if (li?.NewOtherNetCost !== undefined && isNaN(Number(li.NewOtherNetCost))) {
                hasInvalidData = true;
                invalidRowNumbers.push(index + 1);
            }

            // Validate condition cost values (can be negative - discounts allowed)
            if (li?.NewNetConditionCost !== undefined && isNaN(Number(li.NewNetConditionCost))) {
                hasInvalidData = true;
                invalidRowNumbers.push(index + 1);
            }
        });

        if (hasInvalidData) {
            Toaster.error(`Invalid data found in row(s): ${[...new Set(invalidRowNumbers)].join(', ')}. Please fix all validation errors before running simulation.`);
            return false;
        }

        if (hasNegativeBasicRate) {
            Toaster.error(`Basic Rate cannot be negative in row(s): ${[...new Set(invalidRowNumbers)].join(', ')}. Please enter positive values only.`);
            return false;
        }

        if (hasNegativeScrapRate) {
            Toaster.error(`Scrap Rate cannot be negative in row(s): ${[...new Set(scrapRateIssueRows)].join(', ')}. Please enter positive values only.`);
            return false;
        }

        if (hasScrapGreaterThanBasic) {
            Toaster.error(`Scrap Rate cannot be greater than Basic Rate in row(s): ${[...new Set(scrapRateIssueRows)].join(', ')}. Please correct the values.`);
            return false;
        }

        let basicRateCount = 0
        let netLandedCostChangeCount = 0
        let allZeroBasicRates = true;

        list && list.map((li) => {
            const oldNetLandedCost = Number(li.NetLandedCost)
            const newNetLandedCost = Number(checkForNull(li?.NewBasicRate || li?.BasicRatePerUOM) +
                checkForNull(li?.NewOtherNetCost) +
                checkForNull(li?.RMFreightCost) +
                checkForNull(li?.RMShearingCost) +
                checkForNull(li?.NewNetConditionCost))

            // Check if any basic rate is non-zero
            if (checkForNull(li?.NewBasicRate || li?.BasicRatePerUOM) !== 0) {
                allZeroBasicRates = false;
            }

            if (oldNetLandedCost === newNetLandedCost) {
                netLandedCostChangeCount = netLandedCostChangeCount + 1
            }
            if (Number(li.BasicRate) === Number(li.NewBasicRate) || li?.NewBasicRate === undefined) {

                basicRateCount = basicRateCount + 1
            }

            return null;
        })

        // Check if all basic rates are zero
        if (allZeroBasicRates && list.length > 0) {
            Toaster.warning('Basic rate cannot be zero for all items. Please enter valid basic rates.');
            return false;
        }

        if (String(selectedMasterForSimulation?.value) !== String(EXCHNAGERATE) && netLandedCostChangeCount === list.length) {
            Toaster.warning('There is no changes in net cost. Please change the basic rate, then run simulation')
            return false
        }
        setIsDisable(true)
        basicRateCount = 0
        // setShowVerifyPage(true)
        /**********POST METHOD TO CALL HERE AND AND SEND TOKEN TO VERIFY PAGE TODO ****************/
        const check = selectedMasterForSimulation.value === EXCHNAGERATE
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                if (!res?.status && !res?.error) {

                    apiCall(true, res);
                } else {
                    setIsDisable(false)

                }
            }))
        } else {
            apiCall(false, []);
        }
        setShowTooltip(false)
    }, 500)


    const cancelVerifyPage = () => {
        setShowVerifyPage(false)
    }

    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        if (cell != null) {
            const date = DayTime(cell);
            if (date.isValid()) {
                const formattedDate = date.format('DD/MM/YYYY');
                return <span title={formattedDate}> {formattedDate}</span>;
            } else {
                // Fallback: display original value
                const cellStr = String(cell);
                return <span title={cellStr}> {cellStr}</span>;
            }
        }
        return '';
    }

    const costingHeadFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }

    const hyphenFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (isbulkUpload ? row['Customer (Code)'] : row.CustomerName);
    }

    const newBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)

        if (isImpactedMaster) {
            return checkForDecimalAndNull(row.NewBOPRate, getConfigurationKey().NoOfDecimalForPrice);
        }

        const newValue = cell && value ? cell : row?.BasicRate;
        const oldValue = row?.BasicRate;
        const displayValue = checkForDecimalAndNull(newValue, 6);

        return (
            <PriceComparisonSpan
                newValue={newValue}
                oldValue={oldValue}
                costingTypeId={row?.CostingTypeId}
                className="form-control"
                id={`newBasicRate-${props.rowIndex}`}
                title={displayValue}
            >
                {displayValue}
            </PriceComparisonSpan>
        )
    }

    const oldBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        row.OldBOPRate :
                        <span title={cell && value ? Number(cell) : Number(row.BasicRate)}>{cell && value ? Number(cell) : Number(row.BasicRate)} </span>
                }

            </>
        )
    }

    const vendorFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {isbulkUpload ? row[`Vendor (Code)`] : cell}

            </>
        )
    }

    const plantFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {<span title={isbulkUpload ? row['Plant (Code)'] : cell}>{isbulkUpload ? row['Plant (Code)'] : cell}</span>}

            </>
        )
    }

    const costFormatter = (props) => {

        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        if (!row.NewBasicRate || row.BasicRate === row.NewBasicRate || row.NewBasicRate === '') return checkForDecimalAndNull(cell, decimalPlaces)
        const tempA = preciseAdd(Number(row.NewBasicRate), checkForNull(row.RMFreightCost), checkForNull(row.RMShearingCost));
        const classGreen = (tempA > row.NetLandedCost) ? 'red-value form-control' : (tempA < row.NetLandedCost) ? 'green-value form-control' : 'form-class'
        return cell != null ? <span className={classGreen}>{checkForDecimalAndNull(cell, decimalPlaces)}</span> : ''
    }

    /**
    * @method beforeSaveCell
    * @description CHECK FOR ENTER NUMBER IN CELL using common validation
    */
    const beforeSaveCell = (cellValue, props, type) => {
        return validateRevisedRate(cellValue, props, type || 'basicRate', { isBOP: true });
    }

    const NewcostFormatter = (props) => {
        const row = props?.data;

        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1;

        // FIXED: Correct calculation - divide sum by NumberOfPieces, not just OtherNetCost
        const existingBasicPrice = preciseDivide(preciseAdd(Number(row.BasicRate), checkForNull(row?.OtherNetCost)), NumberOfPieces);
        const newBasicPrice = preciseDivide(preciseAdd(Number(row.NewBasicRate || row.BasicRate), checkForNull(row?.NewOtherNetCost || row?.OtherNetCost)), NumberOfPieces);

        const existingNetLandedCost = preciseAdd(existingBasicPrice, checkForNull(row?.NetConditionCost));
        const newNetLandedCost = preciseAdd(newBasicPrice, checkForNull(row?.NewNetConditionCost));

        const displayCost = row.NewBasicRate != null ? newNetLandedCost : existingNetLandedCost;

        if (isImpactedMaster) {
            return row.NewNetBoughtOutPartCost ? checkForDecimalAndNull(row.NewNetBoughtOutPartCost, getConfigurationKey().NoOfDecimalForPrice) : '-'
        } else {
            return (
                <PriceComparisonSpan
                    newValue={newNetLandedCost}
                    oldValue={existingNetLandedCost}
                    costingTypeId={row?.CostingTypeId}
                    className={row.NewBasicRate != null ? "form-control" : ''}
                    title={checkForDecimalAndNull(displayCost, 6)}
                >
                    {checkForDecimalAndNull(displayCost, 6)}
                </PriceComparisonSpan>
            );
        }
    }
    const EditableCallbackForBasicRate = (props) => {
        const rowData = props?.data;

        let value = false
        if ((rowData?.Percentage !== '') && (checkForNull(rowData?.Percentage) !== 0)) {
            value = false
        } else {
            value = true
        }

        setRowIndex(props?.node?.rowIndex)
        setCurrentBopId(rowData?.BoughtOutPartId) // Store BoughtOutPartId for correct row identification
        return value
    }
    const OldcostFormatter = (props) => {
        const row = props?.data;
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        if (isImpactedMaster) {
            return row.OldNetBoughtOutPartCost ? row.OldNetBoughtOutPartCost : '-'
        } else {
            if (!row.BasicRate || row.BasicRate === '') return ''

            const totalCost = preciseAdd(preciseDivide(preciseAdd(Number(row.BasicRate), checkForNull(row?.OtherNetCost)), NumberOfPieces), checkForNull(row?.NetConditionCost));
            return row.BasicRate != null ? <span title={checkForDecimalAndNull(totalCost, decimalPlaces)}>{checkForDecimalAndNull(totalCost, decimalPlaces)}</span> : ''

        }
    }
    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text' id="basicRate_revised">Revised{!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>}</span>
            </div>
        );
    };
    const quantityFormatter = (props) => {

        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(row.Quantity, getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={Number(row.NumberOfPieces)}>{Number(row.NumberOfPieces)} </span>
                }

            </>
        )

    }
    const cancel = () => {
        list && list.map((item) => {
            item.NewBasicRate = undefined
            return null
        })

        props.backToSimulation(true)
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)
    }

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        editable: true,
        suppressSizeToFit: true
    };

    const getRowNodeId = (data) => {
        return data.BoughtOutPartId;
    };

    const onGridReady = (params) => {
        // Use common hook's onGridReady for pagination restoration
        commonOnGridReady(params);

        // Component-specific initialization
        setGridColumnApi(params.columnApi)
        window.screen.width >= 1921 && params.api.sizeColumnsToFit();

        setTimeout(() => {
            setShowTooltip(true)
        }, 100);
    };
    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
        setCurrentPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {
        gridApi.setQuickFilter(e.target.value);
        setTextFilterSearch(e?.target?.value)
    }

    const cellChange = (props) => {
        const rowData = props?.data;
        
        if (rowData && props.colDef && props.colDef.colId === 'NewBasicRate') {
            // Validate basic rate before processing
            const validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
            if (!validation.isValid) {
              
                // Reset to last valid value in both grid and state
                resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                return;
            }
        }
    }
    const resetState = () => {
        // Clear the search input field in DOM
        const searchBox = document.getElementById("filter-text-box");
        if (searchBox) {
            searchBox.value = ""; // Reset the input field's value
        }
        // Clear grid quick filter and text filter state
        gridApi?.setQuickFilter('');
        setTextFilterSearch('');
        // Reset grid column state and filter models
        gridOptions?.columnApi?.resetColumnState();
        gridOptions?.api?.setFilterModel(null);
        // Reset noData state to ensure proper display
        setNoData(false);
        // Resize columns to fit if needed
        if (window.screen.width >= 1440 && gridRef.current?.api) {
            gridRef.current.api.sizeColumnsToFit();
        }
    }
    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }
    const onCellValueChanged = (props) => {
        const rowData = props?.data;

        if (rowData) {
            // Store current page and page size before any updates
            if (gridApi) {
                setCurrentPage(gridApi.paginationGetCurrentPage());
                setCurrentPageSize(gridApi.paginationGetPageSize());
            }

            // CRITICAL FIX: Create deep copy of OLD data BEFORE any changes
            // props.data already has NEW value, so we reconstruct the OLD state
            const rowIndex = props.node.rowIndex;
            const oldRowData = JSON.parse(JSON.stringify(rowData));

            // Restore the OLD value for the changed field
            if (props.colDef?.colId && props.oldValue !== undefined) {
                oldRowData[props.colDef.field || props.colDef.colId] = props.oldValue;
            }

            // Validate the changed value based on the column
            let validation = null;
            if (props.colDef?.colId === 'NewBasicRate') {
                validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
                if (!validation.isValid) {
                    // Reset to last valid value in both grid and state
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // CRITICAL VALIDATION: Basic Rate cannot be negative
                const basicRateValue = Number(rowData.NewBasicRate);
                if (basicRateValue < 0) {
                    Toaster.error('Basic Rate cannot be negative. Please enter a valid positive value.');
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // Save undo state with OLD data (before changes)
                saveUndoState(oldRowData, `Edit Basic Rate`);

                // ENHANCED: Recalculate dependent fields when basic rate changes
                const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(rowData?.NumberOfPieces) : 1;

                // Recalculate NewNetCostWithoutConditionCost
                rowData.NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(rowData.NewBasicRate), checkForNull(rowData?.NewOtherNetCost)), NumberOfPieces);

                // Recalculate NewNetLandedCost
                rowData.NewNetLandedCost = preciseAdd(rowData.NewNetCostWithoutConditionCost, checkForNull(rowData?.NewNetConditionCost));

                // Update NewNetLandedCostConversion and NewNetLandedCostLocalConversion
                rowData.NewNetLandedCostConversion = rowData.NewNetLandedCost;
                rowData.NewNetLandedCostLocalConversion = rowData.NewNetLandedCost;

                // Force refresh of affected cells
                if (gridApi && props.node) {
                    gridApi.refreshCells({
                        rowNodes: [props.node],
                        columns: ['NewNetCostWithoutConditionCost', 'NewNetLandedCost'],
                        force: true
                    });
                }

                // Update state
                setNetCostWithoutConditionCost(rowData.NewNetCostWithoutConditionCost);

                // CRITICAL: Set editRowId so useEffect knows which row to update
                const rowId = rowData?.BoughtOutPartId || rowData?.CostingId;
                setEditRowId(rowId);
            }

            // CRITICAL VALIDATION: Scrap Rate validations
            if (props.colDef?.colId === 'NewScrapRatePerScrapUOM') {
                const scrapRateValue = Number(rowData.NewScrapRatePerScrapUOM);
                const basicRateValue = Number(rowData.NewBasicRate || rowData.BasicRate);

                // Scrap Rate cannot be negative
                if (scrapRateValue < 0) {
                    Toaster.error('Scrap Rate cannot be negative. Please enter a valid positive value.');
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // Scrap Rate cannot be greater than Basic Rate
                if (scrapRateValue > basicRateValue) {
                    Toaster.error(`Scrap Rate (${scrapRateValue}) cannot be greater than Basic Rate (${basicRateValue}). Please enter a valid value.`);
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // Save undo state for scrap rate changes
                saveUndoState(oldRowData, `Edit Scrap Rate`);
            }

            setBasicRate(rowData?.NewBasicRate);
            setRowIndex(props.node.rowIndex);
        }
    }
    const otherCostDrawer = (value, row, index, type) => {
        // CRITICAL FIX: Store unique ID instead of index to handle filtering correctly
        const rowId = row?.BoughtOutPartId || row?.CostingId;

        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        setEditRowId(rowId) // Store ID, not index

        if (type === 'Old') {
            setOtherCostDetailForRow(row?.BoughtOutPartOtherCostDetailsSchema || [])
            setIsViewFlag(true)
        } else {
            setOtherCostDetailForRow(isImpactedMaster ? row?.SimulationBoughtOutPartOtherCostDetailsList : row?.NewBoughtOutPartOtherCostDetailsSchema || []);
            setIsViewFlag(false)
        }
        setOpenOtherCostDrawer(true)
    }
    const closeOtherCostDrawer = (type, tableData, totalCostCurrency, totalCostBase, RowIndex) => {
        // Store current page and page size
        const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
        const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

        if (type === 'Save') {
            calculateAndSave(tableData, totalCostBase);

            // Restore pagination after save
            if (gridApi && savedPage !== undefined) {
                setTimeout(() => {
                    gridApi.paginationGoToPage(savedPage);
                }, 0);
            }
        } else {
            // FIXED: Reset to original on cancel using ID-based lookup
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === editRowId
            );

            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.BoughtOutPartOtherCostDetailsSchema || [];
                setOtherCostDetailForRow([...originalDetails]);

                // Reset the NewOtherNetCost if user canceled
                if (gridApi) {
                    // Use forEachNode to find the correct node regardless of pagination
                    gridApi.forEachNode((node) => {
                        const nodeId = node.data?.BoughtOutPartId || node.data?.CostingId;
                        if (nodeId === editRowId && node.data) {
                            // Restore original values
                            node.data.NewOtherNetCost = list[actualIndex].OtherNetCost;
                            node.data.NewOtherNetCostConversion = list[actualIndex].OtherNetCost;
                            node.data.NewOtherNetCostLocalConversion = list[actualIndex].OtherNetCost;
                            node.data.NewBoughtOutPartOtherCostDetailsSchema = [...originalDetails];

                            // Recalculate dependent fields
                            const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(node.data?.NumberOfPieces) : 1;
                            node.data.NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(node.data.NewBasicRate || node.data.BasicRate), checkForNull(node.data.NewOtherNetCost)), NumberOfPieces);
                            node.data.NewNetLandedCost = preciseAdd(node.data.NewNetCostWithoutConditionCost, checkForNull(node.data?.NewNetConditionCost));

                            // Update list array
                            list[actualIndex] = { ...node.data };

                            // Update grid node
                            node.setData(node.data);
                        }
                    });
                }
            }
        }

        // Update pagination state
        setCurrentPage(savedPage);
        setCurrentPageSize(savedPageSize);

        setOpenOtherCostDrawer(false);
        setIsViewFlag(false);
    }
    const calculateAndSave = (tableData, totalCostBase) => {
        // CRITICAL FIX: Find row by ID instead of using index (handles filtering correctly)
        // Find the actual index in the list array by ID
        const actualIndex = list.findIndex(item =>
            (item.BoughtOutPartId || item.CostingId) === editRowId
        );

        if (actualIndex === -1) {
            Toaster.error('Unable to update Other Cost. Row not found.');
            return;
        }

        try {
            // Store current page and page size before any updates
            const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
            const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

            // CRITICAL FIX: Deep copy old data for undo (not shallow copy)
            const oldData = JSON.parse(JSON.stringify(list[actualIndex]));

            // Get the unique identifier for the row before updates
            const rowId = list[actualIndex]?.BoughtOutPartId || list[actualIndex]?.CostingId;

            // Update other cost values
            list[actualIndex].NewOtherNetCost = totalCostBase;
            list[actualIndex].NewOtherNetCostConversion = totalCostBase;
            list[actualIndex].NewOtherNetCostLocalConversion = totalCostBase;
            list[actualIndex].NewBoughtOutPartOtherCostDetailsSchema = tableData;

            // FIXED: Recalculate dependent fields correctly
            const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(list[actualIndex]?.NumberOfPieces) : 1;
            const basicRate = checkForNull(list[actualIndex].NewBasicRate || list[actualIndex].BasicRate);

            // Calculate NewNetCostWithoutConditionCost correctly (can be negative with discounts)
            list[actualIndex].NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(basicRate, totalCostBase), NumberOfPieces);

            // Recalculate NewNetLandedCost
            list[actualIndex].NewNetLandedCost = preciseAdd(list[actualIndex].NewNetCostWithoutConditionCost, checkForNull(list[actualIndex].NewNetConditionCost));
            list[actualIndex].NewNetLandedCostConversion = list[actualIndex].NewNetLandedCost;
            list[actualIndex].NewNetLandedCostLocalConversion = list[actualIndex].NewNetLandedCost;

            // REMOVED: Warning for negative net cost - negative values are allowed for other costs (discounts)

            // Update state
            setNetCostWithoutConditionCost(list[actualIndex].NewNetCostWithoutConditionCost);
            setCurrentPage(savedPage);
            setCurrentPageSize(savedPageSize);

            // Save undo state after successful update
            saveUndoState(oldData, `Update Other Cost`);

            // CRITICAL FIX: Update the grid node directly using ID, not index
            const node = findNodeByRowId(rowId);
            if (node) {
                node.setData(list[actualIndex]);
            }
        } catch (error) {
            console.error('Error in calculateAndSave:', error);
            Toaster.error('An error occurred while saving other cost.');
        }
    }


    const calculateAndSaveCondition = (tableData, totalCostBase) => {
        // CRITICAL FIX: Find row by ID instead of using index (handles filtering correctly)
        // Find the actual index in the list array by ID
        const actualIndex = list.findIndex(item =>
            (item.BoughtOutPartId || item.CostingId) === editRowId
        );

        if (actualIndex === -1) {
            Toaster.error('Unable to update Condition Cost. Row not found.');
            return;
        }

        try {
            // Store current page and page size before any updates
            const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
            const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

            // CRITICAL FIX: Deep copy old data for undo (not shallow copy)
            const oldData = JSON.parse(JSON.stringify(list[actualIndex]));

            // Get the unique identifier for the row before updates
            const rowId = list[actualIndex]?.BoughtOutPartId || list[actualIndex]?.CostingId;

            // Update condition cost values
            list[actualIndex].NewNetConditionCost = totalCostBase;
            list[actualIndex].NewConditionNetCostConversion = totalCostBase;
            list[actualIndex].NewConditionNetCostLocalConversion = totalCostBase;
            list[actualIndex].NewBoughtOutPartConditionsDetails = tableData;

            // FIXED: Recalculate NewNetLandedCost correctly
            const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(list[actualIndex]?.NumberOfPieces) : 1;
            const basicRate = checkForNull(list[actualIndex].NewBasicRate || list[actualIndex].BasicRate);
            const otherCost = checkForNull(list[actualIndex].NewOtherNetCost);

            // Recalculate NewNetCostWithoutConditionCost
            list[actualIndex].NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(basicRate, otherCost), NumberOfPieces);

            // Recalculate NewNetLandedCost with new condition cost (can be negative)
            list[actualIndex].NewNetLandedCost = preciseAdd(list[actualIndex].NewNetCostWithoutConditionCost, totalCostBase);
            list[actualIndex].NewNetLandedCostConversion = list[actualIndex].NewNetLandedCost;
            list[actualIndex].NewNetLandedCostLocalConversion = list[actualIndex].NewNetLandedCost;

            // REMOVED: Warning for negative net cost - negative values are allowed for condition costs (discounts)

            // Update state
            setCurrentPage(savedPage);
            setCurrentPageSize(savedPageSize);

            // Save undo state after successful update
            saveUndoState(oldData, `Update Condition Cost`);

            // CRITICAL FIX: Update the grid node directly using ID, not index
            const node = findNodeByRowId(rowId);
            if (node) {
                node.setData(list[actualIndex]);
            }
        } catch (error) {
            console.error('Error in calculateAndSaveCondition:', error);
            Toaster.error('An error occurred while saving condition cost.');
        }
    }
    const closeConditionCostDrawer = (type, tableData, totalCostCurrency, conditionCost) => {
        // Store current page and page size
        const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
        const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

        if (type === 'save') {
            const newConditionCost = tableData.reduce((acc, item) => preciseAdd(checkForNull(acc), checkForNull(item?.ConditionCostPerQuantity || 0)), 0);
            calculateAndSaveCondition(tableData, newConditionCost);

            // Restore pagination after save
            if (gridApi && savedPage !== undefined) {
                setTimeout(() => {
                    gridApi.paginationGoToPage(savedPage);
                }, 0);
            }
        } else {
            // FIXED: Reset to original on cancel using ID-based lookup
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === editRowId
            );

            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.BoughtOutPartConditionsDetails || [];
                setConditionCostDetailForRow([...originalDetails]);

                // Reset the NewNetConditionCost if user canceled
                if (gridApi) {
                    // Use forEachNode to find the correct node regardless of pagination
                    gridApi.forEachNode((node) => {
                        const nodeId = node.data?.BoughtOutPartId || node.data?.CostingId;
                        if (nodeId === editRowId && node.data) {
                            // Restore original values
                            node.data.NewNetConditionCost = list[actualIndex].NetConditionCost;
                            node.data.NewConditionNetCostConversion = list[actualIndex].NetConditionCost;
                            node.data.NewConditionNetCostLocalConversion = list[actualIndex].NetConditionCost;
                            node.data.NewBoughtOutPartConditionsDetails = [...originalDetails];

                            // Recalculate NewNetLandedCost
                            const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(node.data?.NumberOfPieces) : 1;
                            node.data.NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(node.data.NewBasicRate || node.data.BasicRate), checkForNull(node.data.NewOtherNetCost)), NumberOfPieces);
                            node.data.NewNetLandedCost = preciseAdd(node.data.NewNetCostWithoutConditionCost, checkForNull(node.data.NewNetConditionCost));

                            // Update list array
                            list[actualIndex] = { ...node.data };

                            // Update grid node
                            node.setData(node.data);
                        }
                    });
                }
            }
        }

        // Update pagination state
        setCurrentPage(savedPage);
        setCurrentPageSize(savedPageSize);

        setOpenConditionCostDrawer(false);
        setIsViewFlag(false);
    }
    const conditionCostDrawer = (value, row, index, type) => {
        // CRITICAL FIX: Store unique ID instead of index to handle filtering correctly
        const rowId = row?.BoughtOutPartId || row?.CostingId;

        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        setEditRowId(rowId) // Store ID, not index

        if (type === 'Old') {
            setConditionCostDetailForRow(row?.BoughtOutPartConditionsDetails || [])
            setIsViewFlag(true)
        } else {
            setConditionCostDetailForRow(isImpactedMaster ? row?.SimulationBoughtOutPartConditionsDetails : row?.NewBoughtOutPartConditionsDetails || [])
            setIsViewFlag(false)
        }
        setOpenConditionCostDrawer(true)
    }
    const existingOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        const value = beforeSaveCell(cell, props, 'otherCost')
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row?.OldOtherCost), getConfigurationKey().NoOfDecimalForPrice) :
                        <span title={cell && value ? Number(cell) : Number(row?.OldNetConditionCost)}>{cell && value ? checkForDecimalAndNull(Number(cell), decimalPlaces) : checkForDecimalAndNull(Number(row?.OtherNetCost), decimalPlaces)} </span>

                }
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const existingConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell, props, 'otherCost')
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;

        // Show "-" for VBC (Vendor Based Costing), show actual value for ZBC (Zero Based Costing)
        const isVendorBased = row?.CostingTypeId === VBCTypeId;

        return (
            <>
                {
                    isVendorBased ?
                        "-" :
                        isImpactedMaster ?
                            checkForDecimalAndNull(Number(row?.OldNetConditionCost), getConfigurationKey().NoOfDecimalForPrice) :
                            <span title={cell && value ? Number(cell) : Number(row?.OldNetConditionCost)}>{cell && value ? checkForDecimalAndNull(Number(cell), decimalPlaces) : checkForDecimalAndNull(Number(row?.OldNetConditionCost), decimalPlaces)} </span>

                }
                {!isVendorBased && true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const revisedOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        const row = props?.valueFormatted ? props.valueFormatted : props?.data;


        const value = beforeSaveCell(cell, props, 'otherCost')
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), decimalPlaces) : checkForDecimalAndNull(Number(row?.OtherNetCost), decimalPlaces)

        setRowIndex(props?.node?.rowIndex)
        return (
            <div className="cell-with-button">
                {
                    isImpactedMaster ?
                    checkForDecimalAndNull(Number(row?.NewOtherCost), getConfigurationKey().NoOfDecimalForPrice) :
                        <PriceComparisonSpan
                            newValue={row?.NewOtherNetCost}
                            oldValue={row?.OtherNetCost}
                            costingTypeId={row?.CostingTypeId}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </div>
        )
    }

    const revisedConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;


        const value = beforeSaveCell(cell, props, 'otherCost')
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        const showValue = cell && value ? checkForDecimalAndNull(Number(cell), decimalPlaces) : checkForDecimalAndNull(Number(row?.NetConditionCost), decimalPlaces)
        setRowIndex(props?.node?.rowIndex)

        // Show "-" for VBC (Vendor Based Costing), show actual value for ZBC (Zero Based Costing)
        const isVendorBased = row?.CostingTypeId === VBCTypeId;

        return (
            <>
                {
                    isVendorBased ?
                        "-" :
                        isImpactedMaster ?
                            row?.NewNetConditionCost :
                            <PriceComparisonSpan
                                newValue={row?.NewNetConditionCost}
                                oldValue={row?.NetConditionCost}
                                costingTypeId={row?.CostingTypeId}
                                className="form-control with-button"
                                title={showValue}
                            >
                                {showValue}
                            </PriceComparisonSpan>

                }
                {/* {!isCostingSimulation && <button */}
                {!isVendorBased && true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => ConditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const basicPriceRevisedFormatter = (props) => {
        const row = props?.data;

        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;

        let returnValue = '';

        const newBasicRate = props?.isImpactedMaster ? checkForDecimalAndNull(row.NewBOPRate, getConfigurationKey().NoOfDecimalForPrice) : (row.NewBasicRate || row.BasicRate);

        const newOtherCost = props?.isImpactedMaster ? checkForDecimalAndNull(row.NewOtherCost, getConfigurationKey().NoOfDecimalForPrice) : (row.NewOtherNetCost || row.OtherNetCost)


        // if ((row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100) {
        //     // If percentage is applied
        //     const basicRateWithPercentage = row.BasicRate + (row.BasicRate * row.Percentage / 100);
        //     returnValue = checkForDecimalAndNull(basicRateWithPercentage + checkForNull(newOtherCost), decimalPlaces);
        // } else {
        // If direct basic rate is used
        returnValue = checkForDecimalAndNull(isImpactedMaster ? row?.NewNetCostWithoutConditionCost : preciseDivide(preciseAdd(checkForNull(newBasicRate), checkForNull(newOtherCost)), NumberOfPieces), decimalPlaces);
        // }

        return (
            <div className='ag-header-cell-label'>
                <span title={returnValue}>{returnValue}</span>
            </div>
        );
    };
    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        return checkForDecimalAndNull(cellValue, decimalPlaces)
    }
    const frameworkComponents = {
        effectiveDateRenderer: effectiveDateFormatter,
        costingHeadFormatter: costingHeadFormatter,
        NewcostFormatter: NewcostFormatter,
        OldcostFormatter: OldcostFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newBasicRateFormatter: newBasicRateFormatter,
        cellChange: cellChange,
        oldBasicRateFormatter: oldBasicRateFormatter,
        vendorFormatter: vendorFormatter,
        plantFormatter: plantFormatter,
        customerFormatter: customerFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        nullHandler: props.nullHandler && props.nullHandler,
        quantityFormatter: quantityFormatter,
        hyphenFormatter: hyphenFormatter,
        existingOtherCostFormatter: existingOtherCostFormatter,
        revisedOtherCostFormatter: revisedOtherCostFormatter,
        existingConditionCostFormatter: existingConditionCostFormatter,
        revisedConditionCostFormatter: revisedConditionCostFormatter,
        basicPriceRevisedFormatter: basicPriceRevisedFormatter,
        localConversionFormatter: localConversionFormatter
    };

    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }
    const scrapRatetooltipToggle = () => {
        setScrapRateViewTooltip(!scrapRateviewTooltip)
    }
    const onBtExport = () => {
        if (String(props?.masterId) === String(BOPIMPORT)) {
            return returnExcelColumn(BOP_IMPACT_DOWNLOAD_EXCEl_IMPORT, list)
        } else {

            return returnExcelColumn(BOP_IMPACT_DOWNLOAD_EXCEl, list)
        }
    };

    const returnExcelColumn = (data = [], TempData) => {
        let tempData = []
        let temp = []
        TempData && TempData.map((item) => {
            const processedItem = { ...item }
            processedItem.EffectiveDate = (processedItem?.EffectiveDate)?.slice(0, 10) || "-";
            if (processedItem?.NewNetLandedCostConversion === null || processedItem?.NewNetLandedCostConversion === undefined) {
                processedItem.NewNetLandedCostConversion = isImpactedMaster ? processedItem?.NewNetBoughtOutPartCost : processedItem?.OriginalNetLandedCost ?? processedItem?.NetLandedCost;
            }
            processedItem.BasicRate = isImpactedMaster ? processedItem?.OldBOPRate : processedItem?.BasicRate
            processedItem.NewBasicRate = isImpactedMaster ? processedItem?.NewBOPRate : processedItem?.NewBasicRate
            processedItem.OtherNetCost = isImpactedMaster ? processedItem?.OldOtherCost : processedItem?.OtherNetCost
            processedItem.NewOtherNetCost = isImpactedMaster ? processedItem?.NewOtherCost : processedItem?.OtherNetCost
            processedItem.NetLandedCost = isImpactedMaster ? processedItem?.OldNetBoughtOutPartCost : processedItem?.NetLandedCost

            Object.keys(processedItem).forEach(key => {
                if (processedItem[key] === null || processedItem[key] === undefined || processedItem[key] === '') {
                    processedItem[key] = "-";
                }
            })
            temp.push(processedItem);
        })
        if (!getConfigurationKey().IsMinimumOrderQuantityVisible) {
            tempData = hideColumnFromExcel(data, 'Quantity')
        } else {
            tempData = data
        }

        // REMOVED: Column filter for condition costs - now shown for both ZBC and VBC
        // The columns will be visible based on IsBasicRateAndCostingConditionVisible config only

        if (isImpactedMaster && temp[0]?.EntryType === "Domestic") {
            tempData = hideColumnFromExcel(data, "LocalCurrency")
        }
        if (isImpactedMaster) {
            tempData = tempData.filter(column => !['BoughtOutPartCategory', 'Vendor', 'Plants', column?.EntryType === "Import" ? "LocalCurrency" : undefined].includes(column.value));
        } else {
            tempData = tempData.filter(column => !['PreviousMinimum', 'PreviousMaximum', 'PreviousAverage',
                'Minimum', 'Maximum', 'Average', 'LocalCurrency'].includes(column.value));
        }
        return (
            <ExcelSheet data={temp} name={`${showBopLabel()} Data`}>
                {tempData && tempData.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }


    return (

        <div>
            <div className={`ag-grid-react`}>
                {
                    !showverifyPage &&
                    <Fragment>
                        {!isImpactedMaster && showTooltip && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised basic rate please double click on the field."}</Tooltip>}
                        {/* {!isImpactedMaster && showTooltip && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={scrapRateviewTooltip} toggle={scrapRatetooltipToggle} target={"scrapRate-tooltip"} >{"To edit revised scrap rate please double click on the field."}</Tooltip>} */}

                        <Row>
                            <Col className={`add-min-height mb-3 sm-edit-page  ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                <div className="ag-grid-wrapper height-width-wrapper">
                                    <div className="ag-grid-header d-flex align-items-center justify-content-between">
                                        <div className='d-flex align-items-center'>
                                            <input type="text" className="form-control table-search" id="filter-text-box" value={textFilterSearch} placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            <button type="button" className="user-btn float-right mr-2" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                           
                                            <ExcelFile filename={`${props.lastRevision ? 'Last Revision Data' : 'Impacted Master Data'}`} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile>
                                        </div>
                                        <div className='d-flex justify-content-end bulk-upload-row pr-0 zindex-2'>
                                            {
                                                isbulkUpload && <>
                                                    <div className="d-flex align-items-center">
                                                        <label>Rows with changes:</label>
                                                        <TextFieldHookForm
                                                            label=""
                                                            name={'NoOfCorrectRow'}
                                                            Controller={Controller}
                                                            title={titleObj.rowWithChanges}
                                                            control={control}
                                                            register={register}
                                                            rules={{ required: false }}
                                                            mandatory={false}
                                                            handleChange={() => { }}
                                                            defaultValue={''}
                                                            className=""
                                                            customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                            errors={errors.NoOfCorrectRow}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <label>Rows without changes:</label>
                                                        <TextFieldHookForm
                                                            label=""
                                                            name={'NoOfRowsWithoutChange'}
                                                            title={titleObj.rowWithoutChanges}
                                                            Controller={Controller}
                                                            control={control}
                                                            register={register}
                                                            rules={{ required: false }}
                                                            mandatory={false}
                                                            handleChange={() => { }}
                                                            defaultValue={''}
                                                            className=""
                                                            customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                            errors={errors.NoOfRowsWithoutChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </>
                                            }
                                             {!isImpactedMaster && (
                                            <>
                                                <UndoButton
                                                    undoCount={undoCount}
                                                    onUndo={handleUndo}
                                                    disabled={isImpactedMaster || !canUndo}
                                                    position="right"
                                                />
                                                <RedoButton
                                                    redoCount={redoCount}
                                                    onRedo={handleRedo}
                                                    disabled={isImpactedMaster || !canRedo}
                                                    position="right"
                                                />
                                            </>
                                            )}
                                            {
                                                !isImpactedMaster && list && <div className={`d-flex align-items-center simulation-label-container`}>
                                                    {list[0]?.CostingTypeId !== CBCTypeId && <div className='d-flex pl-3'>
                                                        <label className='mr-1'>{vendorLabel} (Code):</label>
                                                        <p title={list[0]?.Vendor} className='mr-2'>{list[0]?.Vendor ? list[0]?.Vendor : list?.[0]?.['Vendor (Code)']}</p>
                                                    </div>}
                                                    <button type="button" id="simulation-back" className={"apply back_simulationPage"} onClick={cancel}> <div className={'back-icon'}></div>Back</button>
                                                </div>}
                                        </div>
                                    </div >
                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {list &&
                                            (render ? <LoaderCustom customClass="loader-center" /> : (<AgGridReact
                                                ref={gridRef}
                                                getRowNodeId={getRowNodeId}
                                                floatingFilter={true}
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                domLayout='autoHeight'
                                                // columnDefs={c}
                                                rowData={list}
                                                getRowId={(params) => params.data.BoughtOutPartId || params.data.CostingId}
                                                pagination={true}
                                                paginationPageSize={currentPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                loadingOverlayComponent={'customLoadingOverlay'}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressColumnVirtualisation={true}
                                                stopEditingWhenCellsLoseFocus={true}
                                                onFilterModified={onFloatingFilterChanged}
                                                enableBrowserTooltips={true}
                                                onCellValueChanged={onCellValueChanged}
                                            >
                                                {/* <AgGridColumn field="Technologies" editable='false' headerName="Technology" minWidth={190}></AgGridColumn> */}
                                                {!isImpactedMaster &&<AgGridColumn minWidth={140} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>}
                                                {<AgGridColumn field="EntryType" minWidth={120} headerName="Entry Type" cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>}
                                                <AgGridColumn field="BoughtOutPartNumber" tooltipField='BoughtOutPartNumber' editable='false' headerName="BOP Part No" minWidth={columnWidths?.BoughtOutPartNumber}></AgGridColumn>
                                                <AgGridColumn field="BoughtOutPartName" tooltipField='BoughtOutPartName' editable='false' headerName="BOP Part Name" minWidth={columnWidths?.BoughtOutPartName}></AgGridColumn>
                                                {!isImpactedMaster && <AgGridColumn field="BoughtOutPartCategory" tooltipField='BoughtOutPartCategory' editable='false' headerName="BOP Part Category" minWidth={columnWidths?.BoughtOutPartCategory}></AgGridColumn>}
                                                {!isImpactedMaster && list[0].CostingTypeId !== CBCTypeId && <AgGridColumn field="Vendor" tooltipField='Vendor' editable='false' headerName={vendorLabel + " (Code)"} minWidth={columnWidths?.VendorCode} cellRenderer='vendorFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && list[0].CostingTypeId === CBCTypeId && <AgGridColumn field="CustomerName" tooltipField='CustomerName' editable='false' headerName="Customer (Code)" minWidth={columnWidths?.CustomerName} cellRenderer='customerFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn field="Plants" editable='false' headerName="Plant (Code)" tooltipField='Plant (Code)' minWidth={columnWidths?.plantCode} cellRenderer='plantFormatter'></AgGridColumn>}
                                                {getConfigurationKey().IsMinimumOrderQuantityVisible && <AgGridColumn field="Quantity" tooltipField='Quantity' editable='false' headerName="Min Order Quantity" minWidth={columnWidths?.Quantity} cellRenderer='quantityFormatter'></AgGridColumn>}
                                                {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn minWidth={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source"></AgGridColumn>}
                                                {<AgGridColumn field="Currency" minWidth={180} tooltipField='Currency' editable='false' headerName="Currency/Settlement Currency"  ></AgGridColumn>}
                                                {(String(props?.masterId) === String(BOPIMPORT) || String(props?.masterId) === String(EXCHNAGERATE)) && (isImpactedMaster || props?.lastRevision) && <AgGridColumn field="LocalCurrency" minWidth={120} headerName={"Plant Currency"} cellRenderer={"currencyFormatter"} editable='false'></AgGridColumn>}

                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={
                                                    "Basic Rate (Currency)"

                                                } marryChildren={true} width={columnWidths?.BasicRate.group} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.BasicRate.existing} field="BasicRate" editable='false' cellRenderer='oldBasicRateFormatter' headerName="Existing" colId="BasicRate" suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.BasicRate.revised} cellRenderer='newBasicRateFormatter' onCellValueChanged='cellChange' field="NewBasicRate" editable={isImpactedMaster ? false : EditableCallbackForBasicRate} headerName="Revised" colId='NewBasicRate' headerComponent={'revisedBasicRateHeader'} suppressSizeToFit={true} pinned='right' valueSetter={(params) => {
                                                        // Use the validation-enabled value setter
                                                        return valueSetter(params, 'basicRate');
                                                    }}></AgGridColumn>
                                                </AgGridColumn>

                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.OtherCost.group} headerName={
                                                    "Other Cost (Currency)"

                                                } marryChildren={true} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.OtherCost.existing} cellRenderer='existingOtherCostFormatter' field={isImpactedMaster ? "OldOtherCost" : "OtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OtherNetCost" : "OtherNetCost"} suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.OtherCost.revised} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewOtherCost" : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                {getConfigurationKey().IsBasicRateAndCostingConditionVisible && (list[0].CostingTypeId === ZBCTypeId || list[0].CostingTypeId === VBCTypeId) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicPrice.group} headerName={"Basic Price (Currency)"} suppressSizeToFit={true} marryChildren={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.NetCostWithoutConditionCost} field={isImpactedMaster ? 'OldNetCostWithoutConditionCost' : 'NetCostWithoutConditionCost'} editable='false' headerName="Existing" colId='NetCostWithoutConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.NewNetCostWithoutConditionCost} field="NewNetCostWithoutConditionCost" editable='false' headerName="Revised" cellRenderer='basicPriceRevisedFormatter' colId='NewNetCostWithoutConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>}

                                                {getConfigurationKey().IsBasicRateAndCostingConditionVisible && shouldShowConditionCostColumn && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ConditionCost.group} headerName={"Condition Cost (Currency)"} marryChildren={true} suppressSizeToFit={true} pinned='right'>

                                                    <AgGridColumn width={columnWidths?.ConditionCost.existing} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "OldNetConditionCost" : "NetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.ConditionCost.revised} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewNetConditionCost" : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>}
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.NetCost.group} headerName={
                                                    "Net Cost (Currency)"

                                                } marryChildren={true} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.NetCost.existing} field="OldNetLandedCost" editable='false' cellRenderer={'OldcostFormatter'} headerName="Existing" colId='NetLandedCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.NetCost.revised} field="NewNetLandedCost" editable='false' valueGetter='data.NewBasicRate' cellRenderer={'NewcostFormatter'} headerName="Revised" colId='NewNetLandedCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                {
                                                    (String(props?.masterId) === String(BOPIMPORT) || String(props?.masterId) === String(EXCHNAGERATE)) && (isImpactedMaster || props?.lastRevision) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={`Net Cost (Plant Currency)`} marryChildren={true} width={columnWidths?.PlantCurrency.group} suppressSizeToFit={true} pinned='right'>
                                                        <AgGridColumn width={columnWidths?.PlantCurrency.existing} field="OldBoughtOutPartNetLandedCostLocalConversion" tooltipField='OldBoughtOutPartNetLandedCostConversion' editable='false' headerName="Existing" colId='OldBoughtOutPartNetLandedCostConversion' cellRenderer='localConversionFormatter' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                        <AgGridColumn width={columnWidths?.PlantCurrency.revised} field="NewBoughtOutPartNetLandedCostLocalConversion" editable='false' headerName="Revised" colId='NewBoughtOutPartNetLandedCostConversion' cellRenderer='localConversionFormatter' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    </AgGridColumn>
                                                }
                                                {props?.children}
                                                <AgGridColumn field="EffectiveDate" headerName={props.isImpactedMaster && !props.lastRevision ? "Current Effective date" : "Effective Date"} editable='false' minWidth={columnWidths?.EffectiveDate} cellRenderer='effectiveDateRenderer'></AgGridColumn>
                                                <AgGridColumn field="CostingId" hide={true}></AgGridColumn>



                                            </AgGridReact >))}

                                        {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                    </div >
                                </div >

                            </Col >
                        </Row >
                        {
                            !isImpactedMaster &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                        <DatePicker
                                            name="EffectiveDate"
                                            id="EffectiveDate"
                                            selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                            onChange={handleEffectiveDateChange}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            dateFormat="dd/MM/yyyy"
                                            minDate={maxDate}
                                            placeholderText="Select effective date"
                                            className="withBorder"
                                            autoComplete={"off"}
                                            disabledKeyboardNavigation
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                        {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                    </div>
                                    <button
                                        onClick={verifySimulation}
                                        type="submit"
                                        id="verify-btn"
                                        className="user-btn mr5 save-btn verifySimulation"
                                        disabled={isDisable}
                                        title={
                                            isDisable ? "Simulation is running..." :
                                            !isEffectiveDateSelected ? "Please select an effective date" :
                                            "Click to verify simulation"
                                        }
                                    >
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Verify"}
                                    </button>
                                    {/* <button onClick={runSimulation} type="submit" className="user-btn mr5 save-btn"                    >
                                <div className={"Run"}>
                                </div>{" "}
                                {"RUN SIMULATION"}
                            </button> */}
                                </div>
                            </Row >
                        }
                    </Fragment >

                }
                {
                    showverifyPage &&
                    <VerifySimulation token={token} cancelVerifyPage={cancelVerifyPage} />
                }

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
                {
                    openOtherCostDrawer &&
                    <AddOtherCostDrawer
                        isOpen={openOtherCostDrawer}
                        anchor={"right"}
                        closeDrawer={closeOtherCostDrawer}
                        rawMaterial={true}
                        rmBasicRate={basicRate}
                        ViewMode={isViewFlag}
                        rmTableData={otherCostDetailForRow}
                        RowData={rowData}
                        plantCurrency={rowData?.LocalCurrency}
                        settlementCurrency={rowData?.Currency}
                        isBOP={true}
                        disabled={isImpactedMaster}
                    />
                }
                {
                    getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && openConditionCostDrawer &&
                    <AddConditionCosting
                        isOpen={openConditionCostDrawer}
                        tableData={conditionCostDetailForRow}
                        closeDrawer={closeConditionCostDrawer}
                        anchor={'right'}
                        basicRateBase={netCostWithoutConditionCost}
                        ViewMode={isViewFlag}
                        isFromMaster={true}
                        // isFromImport={states.isImport}
                        // EntryType={checkForNull(ENTRY_TYPE_DOMESTIC)}
                        currency={rowData?.Currency}
                        PlantCurrency={rowData?.LocalCurrency}
                        isBOP={true}
                        disabled={isImpactedMaster}
                    />
                }
            </div >
        </div >
    );
}


export default BDSimulation;